import { ActionTypes } from 'app-modules/viral/actions/types';

export const viralIsEnabledReducer = (previousState = false, action) => {
  let isEnabled = previousState;
  const { payload = false, type } = action;
  if (type === ActionTypes.VIRAL_IS_ENABLED) {
    isEnabled = payload;
  }
  return isEnabled;
};
